module.exports = __webpack_public_path__ + "static/media/postcard11.7379e0f9.jpg";